import { toastr } from 'react-redux-toastr';
import adminDeleteRideBooking from './adminDeleteRideBooking.gql';
import {
  DELETE_BOOKING_START,
  DELETE_BOOKING_SUCCESS,
  DELETE_BOOKING_ERROR
} from '../../../constants';

export default function deleteRideBooking(bookingId) {
  return async (dispatch, getState, { client }) => {
    dispatch({
      type: DELETE_BOOKING_START
    });

    try {
      const { data } = await client.mutate({
        mutation: adminDeleteRideBooking,
        variables: {
          bookingId
        }
      });

      if (data?.adminDeleteRideBooking?.status === 200) {
        dispatch({
          type: DELETE_BOOKING_SUCCESS
        });
        toastr.success('Success', 'The ride booking has been deleted.');
        return {
          status: 200
        };
      }

      dispatch({
        type: DELETE_BOOKING_ERROR
      });
      toastr.error('Error!', data?.adminDeleteRideBooking?.errorMessage || 'Oops! Something went wrong. Please try again.');
      return {
        status: 400
      };
    } catch (err) {
      toastr.error('Error!', err);
      dispatch({
        type: DELETE_BOOKING_ERROR
      });
      return {
        status: 400
      };
    }
  }
};
